if (!customElements.get("parallax-video")) {
  customElements.define(
    "parallax-video",
    class ParallaxVideo extends HTMLElement {
      constructor() {
        super();
        this.button = document.querySelector("[data-video-button]");
        this.buttonContainer = this.button.parentElement

        this.buttonText = this.button ? this.button.textContent.trim() : "";
        this.videos = this.querySelectorAll("video");

        this.isIntersecting = false;
        this.setupIntersectionObserver();
        this.setupClickListener();
      }

      // Get currently visible video
      getVisibleVideo() {
        return Array.from(this.videos).find(video => {
          return window.getComputedStyle(video).display === 'block';
        });
      }

      // Toggle video play/pause state
      toggleVideo() {
        if (!this.getVisibleVideo()) return;

        if (this.button.hasAttribute("data-play")) {
          this.pauseVideo();
        } else {
          this.playVideo();
        }
      }

      playVideo() {
        this.getVisibleVideo().setAttribute("data-play", '');
        this.button.setAttribute("data-play", "");
        setTimeout(() => this.getVisibleVideo().play(), 300);
      }

      pauseVideo() {
        this.getVisibleVideo().pause();
        this.getVisibleVideo().removeAttribute("data-play");
        this.button.removeAttribute("data-play");
      }

      setupIntersectionObserver() {
        if (!this.button) return;

        // Check if screen width is 900px or larger
        const isDesktop = window.matchMedia('(min-width: 900px)').matches;

        const options = {
          root: null,
          rootMargin: isDesktop ? '-80px 0px 0px 0px' : '-60px 0px 0px 0px',
          threshold: isDesktop ? 0.7 : 0.9
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isIntersecting = entry.isIntersecting;

            if (entry.isIntersecting) {
              this.append(this.button);
              this.button.setAttribute("data-move", "");
              this.button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="32" viewBox="0 0 23 32" fill="none">
                <path d="M0.473351 2.02831C0.473351 0.385701 2.34387 -0.556529 3.66381 0.421199L21.8933 13.9245C22.9726 14.724 22.9726 16.3392 21.8933 17.1387L3.66381 30.642C2.34388 31.6197 0.473351 30.6775 0.47335 29.0349L0.473351 14.2211L0.473351 2.02831Z" fill="white"/>
              </svg>`;
            } else {
              // Element is not visible enough - reset button
              this.buttonContainer.append(this.button);
              this.button.removeAttribute("data-move");
              this.button.innerHTML = this.buttonText;
              this.pauseVideo();
            }
          });
        }, options);

        this.observer.observe(this);
      }

      setupClickListener() {
        if (!this.button) return;

        // Handle clicks on the parallax-video element
        this.addEventListener("click", (e) => {
          if (this.isIntersecting && this.button.hasAttribute("data-move")) {
            e.preventDefault();
            this.toggleVideo();
          }
        });

        // Handle direct button clicks
        this.button.addEventListener("click", (e) => {
          if (this.isIntersecting && this.button.hasAttribute("data-move")) {
            e.preventDefault();
            e.stopPropagation();
            this.toggleVideo();
          }
        });
      }

      // Clean up observer when element is removed
      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }
  );
}
